import { routeModule } from '@/routes'
import { getModules } from '@/stores/config'
import { useSelector } from '@/stores/hooks'
import { Route, Switch } from 'wouter'
import { SendToRoute } from './routes/SendToRoute'

export function RouteActions() {
	const modules = useSelector(getModules)

	return (
		<Switch>
			{modules.map(routeModule)}
			<Route path="/*" children={<SendToRoute />} />
		</Switch>
	)
}
